(function () {
    let interval = 5000;
    let selectorClass = ".swiper-slide";
    let activeClass = "active";

    let advanceAnnouncement = function () {
        let announcements = Array.from($(selectorClass));
        let lastAnnouncementIndex = announcements.length - 1;
        let activeAnnouncementIndex;
        for (let i = 0; i < announcements.length; i++) {
            if (announcements[i].classList.contains(activeClass)) {
                activeAnnouncementIndex = i;
            }
        }

        announcements[activeAnnouncementIndex].classList.remove(activeClass);
        activeAnnouncementIndex++;
        if (activeAnnouncementIndex > lastAnnouncementIndex) {
            activeAnnouncementIndex = 0;
        }
        announcements[activeAnnouncementIndex].classList.add(activeClass);




    }
    setInterval(advanceAnnouncement, interval);

})();